export default __webpack_public_path__ + "images/assets/1461d53d806e21e8587a637cb53b9e44.svg";